import {FC, useEffect} from "react";
import {useLocation} from "react-router";
import awsRum from "../lib/awsrum.ts";

const TrackPageViews: FC = () => {
    const location = useLocation()
    useEffect(() => {
        awsRum.recordPageView(location.pathname)
    }, [location])

    return null
}

export default TrackPageViews
